module.exports = __webpack_public_path__ + "static/media/Blessing.abbed85d.jpg";